import {AuthType} from '../constants';
import {SnapAuth} from '../core/snap-auth';
import {LogService} from '../shared/log';
import {SignInForm, UiService} from '../shared/ui';

interface SignInData {
  email: string;
  password: string;
  rememberEmail: boolean;
  returnUrl: string;
}

export class SnapComponent {
  static readonly formName = 'vanilla';

  constructor(
    private readonly snapAuth: SnapAuth,
    private readonly signInForm: SignInForm,
    private readonly ui: UiService,
    private readonly log: LogService,
    private readonly REDIRECT_URL: string,
  ) {
    this.handleSignInInteraction = this.handleSignInInteraction.bind(this);

    this.signInForm.registerInteractionHandler('submit', this.handleSignInInteraction);
  }

  private async handleSignInInteraction(evt: Event) {
    evt.preventDefault();

    const data = this.generateSignInData();
    this.signIn(data);
  }

  private navigate(response: Response) {
    const redirectUrl = response.headers.get(this.REDIRECT_URL);
    window.location.href = redirectUrl || '/';
  }

  private setHelptext(message = '', messages?: Map<string, string>) {
    this.ui.forms.setHelptext(new Map([[SnapComponent.formName, message]]));
    this.ui.controls.setHelptext(messages);
  }

  private async signIn(data: SignInData) {
    try {
      this.ui.masterControl.disabled = true;
      this.ui.masterControl.progress = true;
      this.setHelptext();

      const response = await this.snapAuth.signIn(AuthType.Snap, data);

      this.navigate(response);

    } catch (ex) {
      this.ui.masterControl.disabled = false;
      this.ui.masterControl.progress = false;

      this.signInForm.focus();

      if (this.snapAuth.isAuthException(ex)) {
        this.setHelptext(ex.message, ex.controls);

      } else {
        this.setHelptext(`Can't sign in`);
        const message = typeof ex === 'string' ? ex : ex.message;
        this.log.error(message);
        this.log.sendError(message);
      }
    }
  }

  private generateSignInData(): SignInData {
    const $form = this.signInForm.$ as HTMLFormElement;
    const names: Array<keyof SignInData> = ['email', 'password', 'rememberEmail', 'returnUrl'];
    return names.reduce((acc: Partial<SignInData>, name) => {
      acc[name] = this.getValue(this.getElement($form.elements, name));
      return acc;
    }, {}) as SignInData;
  }

  private getElement(elements: HTMLFormControlsCollection, name: string) {
    const element = elements.namedItem(name);
    return element instanceof NodeList ? element[0] : element;
  }

  private getValue(element: Element | null) {
    if (element instanceof HTMLInputElement) {
      switch (element.type) {
        case 'checkbox':
        case 'radio':
          return element.checked;
        default:
          return element.value;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/snap.component.ts